import React from "react";
import {
  createStyles,
  Box,
  Stack,
  Text,
  Center,
  Image,
  Space,
  Group,
  Anchor,
  List,
  Button,
  Accordion,
} from "@mantine/core";
import AppLogo from "./components/AppLogo";

import { Link, useNavigate, useParams } from "react-router-dom";

function SupportPage({ children, ...otherProps }) {
  const { classes } = useStyles();
  const navigation = useNavigate();
  return (
    <Box className={classes.container} {...otherProps}>
      <Box className={classes.root}>
        <Box className={classes.grid}>
          <Box className={classes.section}>
            <Center px={50} pt={30} pb={10}>
              <Stack spacing={0} justify='center'>
                <Center>
                  <AppLogo
                    variant='white'
                    onClick={() => navigation("/")}
                    sx={{ cursor: "pointer" }}
                  />
                </Center>
              </Stack>
            </Center>
          </Box>

          <Space h={30} />
        </Box>
      </Box>

      <Box className={classes.containerTwo}>
        <Box className={classes.root}>
          <Box className={classes.grid}>
            <Box className={classes.section} mt={50} px={25}>
              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  Support Center
                </Text>

                <Text weight={400} size={18}>
                  Subscription & Billing
                </Text>
              </Stack>

              <Accordion
                // variant="separated"
                multiple={true}
                // disableChevronRotation
              >
                <Accordion.Item value='Cancel a subscription'>
                  <Accordion.Control>
                    <Text weight={600} size='lg'>
                      Cancel a subscription
                    </Text>
                  </Accordion.Control>
                  <Accordion.Panel>
                    <List type='ordered' withPadding>
                      <List.Item>Open the iOS Settings app.</List.Item>
                      <List.Item>Tap on your account name at the top.</List.Item>
                      <List.Item>Tap Subscriptions.</List.Item>
                      <List.Item>Tap on Plantory in the list of subscriptions.</List.Item>
                      <List.Item>Tap Cancel Subscription.</List.Item>
                    </List>
                    For more information, please{" "}
                    <Anchor href='https://support.apple.com/en-us/118428' target='_blank'>
                      check here
                    </Anchor>
                  </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item value='Request a refund'>
                  <Accordion.Control>
                    <Text weight={600} size='lg'>
                      Request a refund
                    </Text>
                  </Accordion.Control>
                  <Accordion.Panel>
                    <List type='ordered' withPadding>
                      <List.Item>
                        Sign in to{" "}
                        <Anchor href='https://reportaproblem.apple.com' target='_blank'>
                          reportaproblem.apple.com
                        </Anchor>
                      </List.Item>
                      <List.Item>
                        Tap or click “I'd like to,“ then choose “Request a refund.“
                      </List.Item>
                      <List.Item>
                        Choose the reason why you want a refund, then choose Next.
                      </List.Item>
                      <List.Item>
                        Find the recent subscription item of the app Plantory, then choose
                        Submit.
                      </List.Item>
                    </List>
                    <Text weight={400}>
                      If your request is approved by Apple, it might take additional time
                      for the funds to return to your payment method.
                    </Text>
                    <Text weight={400}>
                      For more information, please{" "}
                      <Anchor
                        href='https://support.apple.com/en-gb/HT204084'
                        target='_blank'
                      >
                        check here
                      </Anchor>
                    </Text>
                  </Accordion.Panel>
                </Accordion.Item>

                <Accordion.Item value='Restoring a previous purchase'>
                  <Accordion.Control>
                    <Text weight={600} size='lg'>
                      Restoring a previous purchase
                    </Text>
                  </Accordion.Control>
                  <Accordion.Panel>
                    <Text weight={400}>
                      I've you are installing Plantory on a new device, you may need to
                      restore a previous purchase.
                    </Text>
                    <List type='ordered' withPadding>
                      <List.Item>Tap the gear icon to open settings.</List.Item>
                      <List.Item>
                        Tap on “Upgrade to Premium“ at the top of settings.
                      </List.Item>
                      <List.Item>Tap the “Restore“ on the bottom.</List.Item>
                    </List>
                  </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item value='Does the Plantory support Family Sharing'>
                  <Accordion.Control>
                    <Text weight={600} size='lg'>
                      Does the Plantory support Family Sharing?
                    </Text>
                  </Accordion.Control>
                  <Accordion.Panel>
                    <Text weight={400}>
                      Yes, all of the in-app purchases support family sharing.
                    </Text>
                  </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item value='Can I use the Plantory apps without a Premium membership'>
                  <Accordion.Control>
                    <Text weight={600} size='lg'>
                      Can I use the Plantory apps without a Premium membership?
                    </Text>
                  </Accordion.Control>
                  <Accordion.Panel>
                    <Text weight={400}>
                      Yes! The Plantory app can be used without a Premium membership for
                      as long as you'd like.
                    </Text>
                    <Text weight={400}>
                      The Plantory Premium membership unlocks the app's full features, but
                      it's completely optional.
                    </Text>
                  </Accordion.Panel>
                </Accordion.Item>
              </Accordion>

              <Stack spacing={10} justify='left' pl={20}>
                <Text weight={400} size={18}>
                  Get in touch with us, we'ld love to hear from you! We're here to help or
                  answer any additional questions.
                </Text>
                <Box mt={30}>
                  <Button
                    radius='xl'
                    size='md'
                    color='indigo'
                    w={200}
                    onClick={() => navigation("/contact")}
                  >
                    Contact Us
                  </Button>
                </Box>
              </Stack>
            </Box>
            <Space h={30} />
            <Space h={440} />
          </Box>
        </Box>
      </Box>
      <Box className={classes.container}>
        <Box className={classes.root}>
          <Box className={classes.grid} mt={30}>
            <Box className={classes.sectionTwo}>
              <Text weight={400} size={16} align='left' sx={{ color: "gray" }}>
                Made with ❤️ and ☕️ by Anatoli Niculeac<sup>©</sup> 2025
              </Text>
              <Group spacing={10} p={20} position='right'>
                <Anchor component={Link} to={"/support"} className={classes.link}>
                  <Text weight={400} size={16} align='left' sx={{ color: "gray" }}>
                    Support
                  </Text>
                </Anchor>
                <Text weight={400} size={16} align='left' sx={{ color: "gray" }}>
                  |
                </Text>
                <Anchor component={Link} to={"/terms"} className={classes.link}>
                  <Text weight={400} size={16} align='left' sx={{ color: "gray" }}>
                    Terms of use
                  </Text>
                </Anchor>
                <Text weight={400} size={16} align='left' sx={{ color: "gray" }}>
                  |
                </Text>
                <Anchor component={Link} to={"/privacy"} className={classes.link}>
                  <Text weight={400} size={16} align='left' sx={{ color: "gray" }}>
                    Privacy Policy
                  </Text>
                </Anchor>
                <Text weight={400} size={16} align='left' sx={{ color: "gray" }}>
                  |
                </Text>

                <Anchor component={Link} to={"/contact"} className={classes.link}>
                  <Text weight={400} size={16} align='left' sx={{ color: "gray" }}>
                    Contact
                  </Text>
                </Anchor>
              </Group>
              <Space h={10} />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default SupportPage;

const useStyles = createStyles({
  root: {
    height: "100%",
    width: "100%",
    overflowX: "hidden",

    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  },

  container: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "100%",

    "@media (max-width: 768px)": {
      width: "100%",
    },
    width: "100%",
    height: "100%",

    backgroundColor: "#282C2F",
  },
  containerTwo: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "100%",

    "@media (max-width: 768px)": {
      width: "100%",
    },
    width: "100%",
    height: "100%",
    backgroundColor: "#F5F5F7",
  },

  section: {
    maxWidth: 980,
    // width: '100%',
    marginLeft: "auto",
    marginRight: "auto",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "1fr",
    gridGap: "1em",
    gap: 25,
    alignItems: "center",
    paddingLeft: 25,
    paddingRight: 25,
  },

  sectionTwo: {
    maxWidth: 980,
    // width: '100%',
    marginLeft: "auto",
    marginRight: "auto",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr",
    gridGap: "1em",
    gap: "1em",
    alignItems: "center",
    paddingLeft: 25,
    paddingRight: 25,
  },
  grid: {
    display: "grid",
    width: "100%",
    height: "100%",

    gridTemplateColumns: "auto",
    gridTemplateRows: "auto",

    "@media (max-width: 1023px)": {
      gridTemplateColumns: "auto",
      justifyContent: "stretch",
    },

    "@media (min-width: 1600px)": {
      gridTemplateColumns: "auto",
      gridTemplateRows: "auto",
      WebkitTransition: "300ms",
    },
  },
  flex: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",

    gap: 20,
  },
  //   grid: {
  //     display: 'grid',
  //     gridTemplateColumns: '1fr auto 1fr',
  //     gridTemplateRows: 'auto',
  //     justifyContent: 'space-between',

  //     '@media (max-width: 425px)': {
  //       gridTemplateColumns: '1fr',
  //       gridTemplateRows: 'auto',
  //       justifyContent: 'center',
  //       alignContent: 'center',
  //       justifyItems: 'center',
  //     },
  //   },

  link: {
    whiteSpace: "nowrap",
    textDecoration: "none",

    ":last-child": {
      borderRight: "none",
    },

    webkitTransition: "opacity 0.3s cubic-bezier(0.25, 0.1, 0.25, 1)",
    transition: "opacity 0.3s cubic-bezier(0.25, 0.1, 0.25, 1)",
    // WebkitTapHighlightColor: 'rgba(0,0,0,0)',
    // outlineOffset: '-7px',

    ":hover": {
      transition: "0.5s color",
      textDecoration: "none",
      fontWeight: 600,
    },
    transition: "0.5s color",
  },
});
